import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of lines (strings) or children spans.
export const RevealLines = ({ lines = [], className = "", lineClassName = "", delay = 0, stagger = 0.12 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%", rotateX: 12, opacity: 0 }}
            animate={{ y: "0%", rotateX: 0, opacity: 1 }}
            transition={{
              duration: 0.9,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered version for headings deeper in the page.
export const RevealOnScroll = ({ children, className = "", delay = 0, y = 40 }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};
